<template>
  <div class="index">
    <div class="wrap-img"></div>

    <vant-form @submit="onSubmit">
      <cell-group title="受测人信息" v-if="form">
        <template v-for="fd in form.list">
          <field v-if="fd.type == 'input'" :key="fd.key" v-model="info[fd.model]" :name="fd.name" :label="fd.name" :placeholder="fd.name" :field="fd.model" :rules="fd.rules" />
          <field v-else-if="fd.type == 'radio'" :key="fd.key" :name="info[fd.name]" :label="fd.name" :placeholder="fd.name">
            <template #input>
              <radio-group v-model="fd.model" direction="horizontal">
                <radio v-for="op in fd.options.options" :key="op.value" :name="op.value" icon-size="18px">{{ op.lable }}</radio>
              </radio-group>
            </template>
          </field>
          <field v-else-if="fd.type == 'select'" :key="fd.key" readonly clickable name="picker" :value="fd.options.options.map(o => {return o.value})[info[fd.model]]" :label="fd.name" :placeholder="'点击选择'+fd.name" @click="showPicker(fd)" />
          <popup v-if="fd.type == 'select'" :key='fd.key' v-model="info[fd.key]" position="bottom">
            <picker show-toolbar :columns="fd.options.options.map(o => {return o.value})" @confirm="doConfirm" @cancel="hidePicker(fd)" />
          </popup>
        </template>

        <cell style="padding:15px 20px 25px;">
          <vant-button round block type="info" color="#315ace" native-type="submit">提交</vant-button>
        </cell>
      </cell-group>
      <cell-group title="受测人信息" v-else>
        <field v-model="info.trueName" name="姓名" label="姓名" placeholder="姓名" :rules="[{ required: true, message: '请输入您的姓名' }]" />
        <field v-model="info.unit" name="公司" label="公司" placeholder="公司" :rules="[{ required: true, message: '请输入您的公司' }]" />
        <field v-model="info.phone" name="手机号" label="手机号" placeholder="手机号" type="tel" :rules="[{ required: true, message: '请输入手机号',pattern:phonePattern }]" />
        <field v-model="info.department" name="部门" label="部门" placeholder="部门" />
        <field name="性别" label="性别" placeholder="性别">
          <template #input>
            <radio-group v-model="info.sex" direction="horizontal">
              <radio :name="1" icon-size="18px">男</radio>
              <radio :name="0" icon-size="18px" checked-color="#ee0a24">女</radio>
            </radio-group>
          </template>
        </field>
        <field v-model="info.age" name="年龄" label="年龄" placeholder="年龄" />
        <field readonly clickable name="picker" :value="degreeList[info.degree]" label="学历" placeholder="点击选择学历" @click="showDegreePicker = true" />

        <cell style="padding:15px 20px 25px;">
          <vant-button round block type="info" color="#315ace" native-type="submit">提交</vant-button>
        </cell>
      </cell-group>
    </vant-form>


    <popup v-model="showDegreePicker" position="bottom">
      <picker show-toolbar :columns="degreeList" @confirm="degreeConfirm" @cancel="showDegreePicker = false" />
    </popup>
  </div>
</template>
<script>
import { CellGroup, Cell, Field, Button as VantButton, Form as VantForm, RadioGroup, Radio, Popup, Picker, Toast } from "vant";
import { getReportInfo, getSchemeInfo,submitInfo } from "@api/eval";

export default {
  components: {
    VantForm, Field, VantButton, CellGroup, RadioGroup, Radio, Popup, Picker, Cell
  },
  data: function() {
    return {
      projectId: this.$route.params.projectId,
      degreeList: ["小学", "初中", "高中", "专科", "本科", "硕士", "博士", "其他"],
      phonePattern: /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/,
      showDegreePicker: false,
      scheme: null,
      form: null,
      curFd:null,
      info: {
        sex: 1
      }
    };
  },
  created: function() {
    this.init();
  },
  methods: {
    init() {
      this.getReportInfo();
      this.getScheme();
    },
    showPicker(fd){
      this.$set(this.info,fd.key,true)
      this.curFd = fd
    },
    hidePicker(fd){
      this.$set(this.info,fd.key,false)
      this.curFd = null
    },
    doConfirm(val,idx){
      console.info(val,idx)
      this.$set(this.info,this.curFd.key,false)
      this.info[this.curFd.model] = idx

    },
    degreeConfirm(value, idx) {
      this.info.degree = idx;
      this.showDegreePicker = false;
    },
    getScheme() {
      getSchemeInfo(this.projectId).then(res => {
        this.scheme = res.result || {};
      });
    },
    getReportInfo() {
      getReportInfo(this.projectId).then(res => {
        if(res.result.user.controlItems){
          this.info = res.result.user.controlItems || {};
        }else{
          this.info = res.result.user || {};
        }
        this.form = res.result.form

        console.info(this.info,this.form,res.result)

        //1、判断报告状态，如果已完成答题，直接跳转到答题结果页
      });
    },
    onSubmit() {
      Toast.loading({ duration: 0, forbidClick: true, message: "加载中..." });
      submitInfo(this.projectId, this.info).then(res => {
        Toast.clear();
        if (res.code == 200) {
          if(this.scheme.flag ==='fenc-m'||this.scheme.flag ==='fenc-simple'){
            this.$router.replace({ path: `/eval/post/${this.projectId}` });
          }else {
            this.$router.replace({ path: `/eval/start/${this.projectId}` });
          }
        } else {
          Toast(res.message);
        }
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.index {
  background-color: #f5f5f5;
  height: 100vh;
  min-height: 500px;
  .wrap-img {
    height: 180px;
    background: url("~@images/banner.jpg") 0 0 no-repeat;
    background-size: cover;
  }

  .notice {
    font-size: 14px;
    background-color: #fff;
  }

}
</style>
